var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#8D40FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 6.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 33.5c0-6.4 5.1-10.5 11.5-10.5s11.5 4.1 11.5 10.5c0 .8-.7 1.5-1.5 1.5H11c-.8 0-1.5-.7-1.5-1.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminUser);
export default __webpack_public_path__ + "static/media/admin-user.a2c29bb1fdcea86d7965b02ea18fd553.svg";
export { ForwardRef as ReactComponent };